import _ from 'lodash';
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { programs } from '../../../redux/programs/action';
import { useAppDispatch } from '../../../hooks/hooks';
import { SubscriptionForm } from './subscription-form';
import { selectProgramsQueryItems } from '../../../redux/programs/selector';
import { selectEnvironmentsListItems } from '../../../redux/environments/selector';
import { selectEndpointsListItems } from '../../../redux/endpoints/selector';
import { selectNetworksListItems } from '../../../redux/networks/selector';
import { selectApplicationsListItems } from '../../../redux/applications/selector';
import { selectPhasesListItems } from '../../../redux/phases/selector';
import { selectServicesListItems } from '../../../redux/services/selector';
import { selectDigitalPrivateInfrastructuresListItems } from '../../../redux/digital-private-infrastructures/selector';
import { selectDigitalPublicInfrastructuresListItems } from '../../../redux/digital-public-infrastructures/selector';
import { environments } from '../../../redux/environments/action';
import { networks } from '../../../redux/networks/action';
import { phases } from '../../../redux/phases/action';
import { digitalPrivateInfrastructures } from '../../../redux/digital-private-infrastructures/action';
import { digitalPublicInfrastructures } from '../../../redux/digital-public-infrastructures/action';
import { services } from '../../../redux/services/action';
import { applications } from '../../../redux/applications/action';
import { endpoints } from '../../../redux/endpoints/action';
import { currency } from '../../../common/services/common.service';
import { subscriptions } from '../../../redux/subscriptions/action';
import { selectSubscriptionsCreatedItem, selectSubscriptionsQueryItems } from '../../../redux/subscriptions/selector';
import { razorpay } from "../../../redux/razporpay/action";
import { selectCreatedItem, selectUpdatedItem as selectInitiateRazorpayDetails } from "../../../redux/razporpay/selector";
import storePersist from '../../../redux/storePersist';
import { toast } from 'react-toastify';
import { npsubscriptions } from '../../../redux/np-subscriptions/action';
import { selectnpsubscriptionsQueryItems } from '../../../redux/np-subscriptions/selector';
declare let Razorpay: any;
import { selectListItems } from '../../../redux/library/selector';


export default function SubscriptionDetail() {
    const navigate = useNavigate();
    const initiateRazorpay = useSelector(selectInitiateRazorpayDetails);
  const dispatch = useAppDispatch();
  const [dbaasProgram, setDBaasProgram] = useState<any>(null);
  const itemsData = useSelector(selectProgramsQueryItems);
   const subscriptionqueryData = useSelector(selectSubscriptionsQueryItems);
    const npsubscriptionqueryData = useSelector(selectnpsubscriptionsQueryItems);
  const endpointItems = useSelector(selectEndpointsListItems);
  const environmentItems = useSelector(selectEnvironmentsListItems);
  const networkItems = useSelector(selectNetworksListItems);
  const applicationItems = useSelector(selectApplicationsListItems);
  const phasesItems = useSelector(selectPhasesListItems);
  const serviceItems = useSelector(selectServicesListItems);
  const privateItems = useSelector(selectDigitalPrivateInfrastructuresListItems);
  const publicItems = useSelector(selectDigitalPublicInfrastructuresListItems);
    const subscriptionsData = useSelector(selectSubscriptionsCreatedItem);
  const [isQuery, setIsQuery] = useState<boolean>(false);

  const [existingSubscription, setExistingSubscription] = useState<any>(null);
const [showConfirmModal, setShowConfirmModal] = useState(false);
const [actionType, setActionType] = useState<'subscribe' | 'enableAsNew' | null>(null);
const handleConfirm = () => {
  if (actionType === 'subscribe') {
    handleSubscribe();
  } else if (actionType === 'enableAsNew') {
    handleSubscriptionForAnotherDomain();
  }
  setShowConfirmModal(false);
  setActionType(null);
};
  const image = require('../../../assets/img/image 1.png');
  const params: any = useParams();
  const libraryData = useSelector(selectListItems)
  const Programname = libraryData?.result?.ProgramType;
  const selectedProgramTypeId = dbaasProgram?.ProgramTypeId; 
const selectedProgram = Programname?.find(
  (item) => item.Value === selectedProgramTypeId
);
const programText = selectedProgram?.Text || "Unknown Program";

  const fetchProgramById = () => {
     dispatch(subscriptions.resetAction({ actionType: 'create' }));
      dispatch(razorpay.resetAction({ actionType: 'createRazorpay' }));
    dispatch(programs.query({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/query`,
      entity: 'programs',
      jsonData: {
        Records: [{ "Id": params?.id }]
      }
    })).then(() => {
      setIsQuery(true);
    });
  };

  const checkExistingSubscription = () => {
      dispatch(razorpay.resetAction({ actionType: 'createRazorpay' }));
    dispatch(subscriptions.query({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbaas/subscriptions/query-by-current-user`,
      entity: 'subscriptions',
      jsonData: {
       
    "Context": {
        "Subscription": "ONE",
        "Domain": "ONE",
        "SubDomains": [],
        "Network": "Venture",
        "Application": "Venture",
        "Channel": "CSP"
    },
    "Records": [
        {
            "UserProfileId": 0
        }
    ]
}
      }
    ))
  }

  useEffect(() => {
     dispatch(subscriptions.resetAction({ actionType: 'create' }));
     dispatch(razorpay.resetAction({ actionType: 'createRazorpay' }));
    dispatch(endpoints.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/endpoints/list`, entity: 'endpoints', jsonData: {} }))
      .then(() => {
        dispatch(environments.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/environments/list`, entity: 'endpoints', jsonData: {} }));
      }).then(() => {
        dispatch(networks.list({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`, entity: 'endpoints', jsonData: {} }));
      }).then(() => {
        dispatch(phases.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/phases/list`, entity: 'phases', jsonData: {} }));
      }).then(() => {
        dispatch(digitalPrivateInfrastructures.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-private-infrastructures/list`, entity: 'digitalPrivateInfrastructures', jsonData: {} }));
      }).then(() => {
        dispatch(digitalPublicInfrastructures.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-public-infrastructures/list`, entity: 'digitalPublicInfrastructures', jsonData: {} }));
      }).then(() => {
        dispatch(services.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/services/list`, entity: 'services', jsonData: {} }));
      }).then(() => {
        dispatch(applications.list({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/applications/list`, entity: 'applications', jsonData: {} }));
      }).then(() => {
        fetchProgramById();
      });
  }, []);

  useEffect(() => {
    if (subscriptionqueryData?.isSuccess && subscriptionqueryData?.result?.items) {
     setExistingSubscription(subscriptionqueryData?.result?.items?.Id);
    }
    else{
       setExistingSubscription(null);
    }
  }, [subscriptionqueryData]);


  const getOwnerTypeByProgramTypeId = (programTypeId: number) => {
  switch (programTypeId) {
    case 10:
      return "DBaaSSubscription";
    case 20:
      return "DBNBizSubscription";
    case 30:
      return "DBNAgentSubscription";
    case 40:
      return "DBNPartnerSubscription";
    default:
      return "UnknownSubscription";
  }
};
  useEffect(() => {

    if (subscriptionsData?.isSuccess && subscriptionsData?.result?.Records?.[0]?.Id) {
      const ownerType = getOwnerTypeByProgramTypeId(dbaasProgram?.ProgramTypeId);
      const orderId = subscriptionsData?.result?.Records?.[0]?.Id;
      let url = "";
    let entity = "";
    switch (dbaasProgram?.ProgramTypeId) {
      case 10:
         url = `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbaas/subscriptions/query`;
        entity = "DBaasSubscription";
        break;
      case 20:
        url = `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbn-biz-subscriptions/query`;
        entity = "dbnBizSubscriptions";
        break;
      case 30:
        url = `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbn-agent-subscriptions/query`;
        entity = "dbnAgentSubscriptions";
        break;
      case 40:
        url = `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbn-partner-subscriptions/query`;
        entity = "dbnPartnerSubscriptions";
        break;
      default:
        console.warn("No matching subscription API for ProgramTypeId:", dbaasProgram?.ProgramTypeId);
        return;
    }

    dispatch(
      npsubscriptions.query({
        url,
        entity,
        jsonData: {
          Context: {
            Subscription: "ONE",
            Domain: "ONE",
            SubDomains: [],
            Network: "Venture",
            Application: "Venture",
            Channel: "CSP"
          },
          Records: [
            {
             Id: orderId
            }
          ]
        },
      })
    ) .then(() => {
      dispatch(razorpay.resetAction({ actionType: 'createRazorpay' }));
      dispatch(razorpay.createRazorpay({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/orders/initiate-online-order-payment-rp`,
        entity: 'razorpayInitiate',
        jsonData: {
          Records: [
            {
              OwnerType: ownerType,
              OrderId: subscriptionsData?.result?.Records?.[0]?.Id,
            }
          ]
        }
      }))})
      dispatch(subscriptions.resetAction({ actionType: 'list' }));
    }

    else{
      const errorMessage = subscriptionsData?.result?.Error?.Message;
  if (errorMessage) {
    toast.error(errorMessage); // 🔔 Show the error as a toast
    return;
  }
    }
  }, [subscriptionsData]);

useEffect(() => {
  dispatch(subscriptions.resetAction({ actionType: "create" }));

  const script = document.createElement("script");
  script.src = "/checkout.js";
  script.async = true;

  script.onload = () => {
    if (initiateRazorpay?.isSuccess && initiateRazorpay?.result[0]?.Id) {
      initiateRazorPayPayment();
    }
  };

  document.body.appendChild(script);

  return () => {
    // Optional cleanup if needed
    document.body.removeChild(script);
  };
}, [initiateRazorpay]);

  const initiateRazorPayPayment = () => {
    const tokenData = storePersist?.get("accessToken")?.current;
     const ownerType = getOwnerTypeByProgramTypeId(dbaasProgram?.ProgramTypeId);
    const options = {
      key: initiateRazorpay?.result[0]?.PaymentGatewayKey,
      name: tokenData?.TokenMetadata?.CompanyName,
      currency: "INR",
      image: 'https://114digiistorage217.blob.core.windows.net/organization/organizationunit/quco-fav.png',
      description: initiateRazorpay?.result[0]?.Description,
      payment: {
        capture: 'automatic',
        capture_options: {
          automatic_expiry_period: 12,
          manual_expiry_period: 7200,
          refund_speed: 'optimum',
        },
      },
       prefill: {
        email: npsubscriptionqueryData?.result?.items?.Email,
        contact: npsubscriptionqueryData?.result?.items?.PhoneNumber,
        name: npsubscriptionqueryData?.result?.items?.BusinessName,
      },
      handler: (data: any) => {
        if (data?.razorpay_payment_id) {
          dispatch(razorpay.completeRazorpay({
            url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/orders/complete-online-order-payment-rp`,
            entity: 'razorpaycomplete',
            jsonData: {
              Records: [
                {
                  RazorPayOrderId: data?.razorpay_order_id,
                  RazorPaySignature: data?.razorpay_signature,
                  RazorPayPaymentId: data?.razorpay_payment_id,
                  OwnerType: ownerType,
                },
              ],
            }
          })).then(() => {
     
            navigate(`/`);
            toast.success('Program Purchased Successfully');
          });
        }
      },
      theme: {
        color: '#F37254',
      },
      order_id: initiateRazorpay?.result[0]?.PaymentGatewayOrderReferanceId,
    };
    const rzp1 = new Razorpay(options);
    rzp1.open();
    dispatch(razorpay.resetAction({ actionType: 'createRazorpay' }));
  };

  const handleSubscriptionForAnotherDomain = () => {
      dispatch(subscriptions.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbaas/subscriptions`,entity:'subscriptions',jsonData:{
        "Context": {
        "Subscription": "ONE",
        "Domain": "ONE",
        "SubDomains": [],
        "Network": "Venture",
        "Application": "Venture",
        "Channel": "CSP"
    },
     "Records": [
    {
            OwnerType: 'DBaasProgram',
              OwnerId: dbaasProgram?.Id,
              Name: dbaasProgram?.Name,
              Description: dbaasProgram?.Description,
              Amount: dbaasProgram?.DBaaSProgram[0]?.Price,
              Validity: dbaasProgram?.DBaaSProgram[0]?.ProgramDuration,
              EnableAsNew: false
    }
  ]
        }}))
    }
  const handleSubscribe = async () => {
    let url = "";
    let entity = "";
    switch (dbaasProgram?.ProgramTypeId) {
      case 20:
        url = `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbn-biz-subscriptions`;
        entity = "dbnBizSubscriptions";
        break;
      case 30:
        url = `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbn-agent-subscriptions`;
        entity = "dbnAgentSubscriptions";
        break;
      case 40:
        url = `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbn-partner-subscriptions`;
        entity = "dbnPartnerSubscriptions";
        break;
      default:
        console.warn("No matching subscription API for ProgramTypeId:", dbaasProgram?.ProgramTypeId);
        return;
    }

    dispatch(
      subscriptions.create({
        url,
        entity,
        jsonData: {
          Context: {
            Subscription: "ONE",
            Domain: "ONE",
            SubDomains: [],
            Network: "Venture",
            Application: "Venture",
            Channel: "CSP"
          },
          Records: [
            {
              OwnerType: 'DBaasProgram',
              OwnerId: dbaasProgram?.Id,
              Name: dbaasProgram?.Name,
              Description: dbaasProgram?.Description,
              Amount: dbaasProgram?.DBaaSProgram[0]?.Price,
              Validity: dbaasProgram?.DBaaSProgram[0]?.ProgramDuration,
            }
          ]
        },
      })
    );
  };

  useEffect(() => {
    if (isQuery) {
      const program = itemsData?.result?.items;
      setDBaasProgram(program);
      if (program?.ProgramTypeId === 10) {
        checkExistingSubscription();
      }
    }
  }, [isQuery, itemsData]);

  useEffect(() => {
    if (isQuery) {
      setDBaasProgram(itemsData?.result?.items);
    }
  }, [isQuery, itemsData]);
  const getNameById = (id: any, list: any) => {
    const item = list?.find((item: any) => item.Id === id);
    return item ? item.Name : id;
  };

  return (
    <div className="contact-wrapper w-full p-10 mb-10">
      <div className="container-x mx-auto">
        <div className="main-wrapper w-full lg:flex lg:space-x-10 lg:items-stretch">

          {/* Left: Program Details */}
          <div className="lg:w-2/3 w-full mb-10 lg:mb-0 flex flex-col">
            <div className="p-6 rounded-lg bg-white shadow-md mb-6 flex-grow">
              <h1 className="text-blue-900 font-bold text-3xl mb-4">
                {`${dbaasProgram?.Name} Subscription`}
              </h1>

              <div className="flex items-center justify-between p-4 rounded-lg bg-blue-100 shadow-md h-30 mt-12">
                <div>
                  <h2 className="text-blue-900 text-2xl font-bold">Cost</h2>
                  <h3 className="mt-2 text-3xl font-bold text-yellow-500 text-left">
                    {currency(dbaasProgram?.DBaaSProgram?.[0]?.Price)}
                  </h3>
                </div>
                <div className="bg-gradient-to-tr from-yellow-500 to-yellow-400 w-32 h-32 rounded-full shadow-2xl shadow-yellow-400 border-white border-dashed border-2 flex justify-center items-center">
                  <div>
                    <h1 className="text-white text-2xl text-center">
                      Validity <br />
                      {`${dbaasProgram?.DBaaSProgram?.[0]?.ProgramDuration}`}
                    </h1>
                  </div>
                </div>
              </div>

              {/* Program Details Table */}
              <div className="p-4 rounded-lg bg-white shadow-md mt-6 w-full flex-grow">
                <h3 className="text-2xl font-medium text-blue-900 mb-4">
                  Program Details
                </h3>

                {dbaasProgram && (
                  <div className="table w-full mt-10">
                    <div className="table-row-group">
                      {[
                        { label: 'DBaas End Points', value: dbaasProgram?.DBaaSProgram?.[0]?.DBaaSEndPointIds, list: endpointItems?.result?.items },
                        { label: 'DBaas Environments', value: dbaasProgram?.DBaaSProgram?.[0]?.DBaaSEnvironmentIds, list: environmentItems?.result?.items },
                        { label: 'DBaas Networks', value: dbaasProgram?.DBaaSProgram?.[0]?.DBaaSNetworkIds, list: networkItems?.result?.items },
                        { label: 'DBaas Applications', value: dbaasProgram?.ApplicationMappings?.ApplicationIds, list: applicationItems?.result?.items },
                        { label: 'DBaas Phases', value: dbaasProgram?.DBaaSProgram?.[0]?.DBaaSPhaseIds, list: phasesItems?.result?.items },
                        { label: 'DBaaS Services', value: dbaasProgram?.DBaaSProgram?.[0]?.DBaaSServiceIds, list: serviceItems?.result?.items },
                        { label: 'Digital Private Infrastructures', value: dbaasProgram?.DBaaSProgram?.[0]?.DigitalPrivateInfrastructureIds, list: privateItems?.result?.items },
                        { label: 'Digital Public Infrastructures', value: dbaasProgram?.DBaaSProgram?.[0]?.DigitalPublicInfrastructureIds, list: publicItems?.result?.items },
                      ].map((item, index) => (
                        <div key={index} className={`table-row ${index % 2 === 0 ? 'bg-gray-100' : ''}`}>
                          <div className="table-cell p-2 text-md font-semibold">{item.label}</div>
                          <div className="table-cell p-2">
                            {item.value?.map((id: any) => (
                              <div key={id}>{getNameById(id, item.list)}</div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Case 1: For all other programs */}
      {dbaasProgram?.ProgramTypeId !== 10 && (
        <div className="mt-6 w-full flex justify-center">
         <button
  onClick={() => {
    setActionType('subscribe');
    setShowConfirmModal(true);
  }}
  className="px-6 py-3 bg-blue-700 text-white font-semibold rounded-lg shadow hover:bg-blue-800 transition"
>
  Subscribe
</button>
        </div>
      )}

      {/* Case 2: If type is 10 and subscription exists */}
      {dbaasProgram?.ProgramTypeId === 10 && existingSubscription !== null && (
        <div className="mt-6 w-full flex justify-center">
         <button
  onClick={() => {
    setActionType('enableAsNew');
    setShowConfirmModal(true);
  }}
  className="px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition"
>
  Enable as New
</button>
        </div>
      )}
              </div>
            </div>
          </div>
{showConfirmModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md text-center">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Do you want to add this subscription to the existing one?
      </h2>
      <div className="flex justify-center gap-4 mt-6">
        <button
          onClick={handleConfirm}
          className="bg-blue-700 text-white px-4 py-2 rounded-lg hover:bg-blue-800"
        >
          Yes
        </button>
        <button
          onClick={() => {
            setShowConfirmModal(false);
            setActionType(null);
          }}
          className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
        {dbaasProgram && (
            <div className="lg:w-1/3 w-full flex flex-col items-center lg:items-start space-y-6 flex-grow">
              <div className="w-full flex flex-col items-center flex-grow">
                <div className="flex-grow flex items-center justify-center">
                  <img
                    src={dbaasProgram?.MediaMappings?.MediaFiles?.[0]?.FileMappingURL || image}
                    alt="DBaaS Program"
                    className="rounded-lg shadow-md object-contain max-h-full max-w-full"
                  />
                </div>
              </div>

                {(dbaasProgram?.ProgramTypeId === 10 && existingSubscription === null)  && (
                <div className="w-full p-6 bg-white shadow-md rounded-lg flex-grow mb-1">
                  <SubscriptionForm item={dbaasProgram} />
                </div>
              )}
            
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
